import AuthLink from "common/AuthLink";

const mapKeyValues = (cell, field) => {
  const data = cell._cell.row.getData();
  const value = data[field] === 1 || data[field] === true ? "Yes" : "No";
  cell._cell.column.tooltip = value;
  let accessorDownload = {
    accessor: mapKeyDownloadFormatter,
    params: { value },
  };
  let accessor = { accessorDownload };
  cell._cell.column.modules.accessor = accessor;
  return value;
};

const mapKeyValuesForAdminState = (cell, field) => {
  const data = cell._cell.row.getData();
  console.log(data[field]);
  const value = data[field] === 1 || data[field] === true ? "Enabled" : "Disabled";
  cell._cell.column.tooltip = value;
  let accessorDownload = {
    accessor: mapKeyDownloadFormatter,
    params: { value },
  };
  let accessor = { accessorDownload };
  cell._cell.column.modules.accessor = accessor;
  return value;
};
const mapKeyDownloadFormatter = (value, data, type, params, column) => {
  return params.value;
};

const addLink = (cell) => {
  let value = cell.getValue();
  //value = '<a href={' + value + '} target="_blank">';
  console.log(value)
  return value;
}

const getDocumentName = (cell) => {
  const value = cell.getValue();
  //console.log(value);
  // const documentName = value.substring(value.lastIndexOf('/') + 1);
  return value === undefined ? value : value.substring(value.lastIndexOf('/') + 1);
};

export const AuthLinkCellFormatter = (props: any) => {
  const href = `${props.urlPrefix}/${props.cell._cell.value || '???'}`;
  const target = props.target || '_blank';
  const value= getDocumentName(props.cell);
  return <AuthLink href={href} target={target} value={value} />
};

export default {
  mapKeyValues,
  mapKeyValuesForAdminState,
  getDocumentName,
  addLink
};
